<template>
  <div class="animated fadeIn">
    <b-card :header="config.header">
			<b-select v-model="statusSelected" :options="statusOptions" class="d-inline-block" style="width: 200px;"></b-select>
			<b-select v-if="!(is('playGameSnackgame') || is('playGameRecommend') || is('playGameBanner'))" v-model="linkedSvcTypeSelected" :options="linkedSvcTypeOptions" class="d-inline-block ml-2" style="width: 200px;"></b-select>
			<b-select v-if="!(is('playGameSnackgame') || is('playGameRecommend') || is('playGameBanner'))" v-model="osTypeSelected" :options="osTypeOptions" class="d-inline-block ml-2" style="width: 200px;"></b-select>
			<b-form-input id="game" v-model="search" :placeholder="is('playGameBanner') ? '프로모션명을 입력해주세요.' : '게임명을 입력해주세요.'" class="d-inline-block ml-2" style="width: 250px;"></b-form-input>
			<b-button v-if="!(is('playGameSnackgame') || is('playGameRecommend'))" class="d-inline-block ml-2 float-right" :to="{name: config.type + 'New'}" type="button">등록</b-button>
		<b-button v-if="!(is('playGameSnackgame') || is('playGameRecommend'))" class="d-inline-block ml-2 float-right" :to="{name: config.type + 'GapNew'}" type="button">광고 사전예약 등록</b-button>
			<!--<b-button v-if="!(is('playGameSnackgame') || is('playGameRecommend'))" class="d-inline-block ml-2 float-right" v-b-modal.dragItem type="button">가중치 설정</b-button>-->
			<b-button v-if="(is('playGameSnackgame') || is('playGameRecommend'))" class="d-inline-block ml-2 float-right" :to="{name: config.type + 'Editor'}" type="button">등록/수정</b-button>
			<b-table class="mt-3" hover striped bordered small fixed responsive="sm" :items="filteredList" :fields="getTableField()" :current-page="currentPage" :per-page="perPage" :show-empty=true empty-text="리스트가 없습니다." :sort-by.sync="sortBy" :sort-desc=true><!--:sort-by="sortBy" :sort-desc="true" -->
				<template slot="number" slot-scope="data">
						{{data.item.seq}}
				</template>
				<template slot="title" slot-scope="data">
						<!--<b-link :to="{name: config.type + 'Edit', params: {pgmAdId: data.item.seq, linkedSvcType: data.item.linkedSvcType}}" class="mr-2">{{data.item.title || '-'}}</b-link>-->
					<b-link @click="movePgmAdEditPage(data.item)" class="mr-2">{{data.item.title || '-'}}</b-link>
				</template>
				<template slot="type" slot-scope="data">
						{{getLinkedSvcType(data.item.linkedSvcType)}}
				</template>
				<template slot="image" slot-scope="data">
						<img style="width:100%" :src="getBannerImage(data.item.viewInfo)"
                 @mouseenter="mouseEnterToBannerImage" @mouseleave="mouseLeaveFromBannerImage"/>
				</template>
				<template slot="osType" slot-scope="data">
						{{ osTypeDesc[data.item.osType] }}
				</template>
				<template slot="zzd" slot-scope="data">
						{{getStatusName(data.item.status)}}
				</template>
				<template slot="displayYn" slot-scope="data">
						<select :ref="'type' + data.item.seq" :value="data.item.displayYn" v-on:change="changeHandling(data.item, $event)">
								<option :value=DISPLAY_STATE.ON>ON</option>
								<option :value=DISPLAY_STATE.OFF>OFF</option>
								<option :value=DISPLAY_STATE.BETA>BETA</option>
						</select>
				</template>
				<template slot="startTime" slot-scope="data">
						{{data.item.startTime ? data.item.startTime.format('YY.MM.DD HH:mm') : '미등록'}}
				</template>
				<template slot="endTime" slot-scope="data">
						{{data.item.endTime ? data.item.endTime.format('YY.MM.DD HH:mm') : '미등록'}}
				</template>
				<template slot="modTime" slot-scope="data">
						{{data.item.modTime ? data.item.modTime.format('YY.MM.DD HH:mm') : '미등록'}}
				</template>
				<template slot="weight" slot-scope="data">
					<select type="number" v-model="data.item.orderNo" v-on:change="weightHandler(data.item)">
						<option :key="'orderNo' + index" v-for="(item, index) in orderOptions" :value="item.value">{{item.value}}</option>
					</select>
				</template>
			</b-table>
			<nav>
				<b-pagination :total-rows="filteredList.length" :per-page="perPage" v-model="currentPage" prev-text="<" next-text=">" hide-goto-end-buttons/>
			</nav>
		<p>
			<!--v-if="is('playGameBanner') || is('playGameMainstream') || is('playGameFrontPopup') || is('playGameEmoticon')"-->
			진행중인 배너는 기본적으로 랜덤 노출되며, 기본가중치는 1입니다.
			<br>
			노출가중치는 '해당 배너의 노출가중치 / 진행중 배너들의 노출가중치 총합'으로 계산되어 노출량이 결정되니 참고부탁드립니다.
		</p>
    </b-card>
		<!--<b-modal size="lg" id="dragItem" title="순서설정" cancel-title="취소" ok-title="확인" @ok="changeListOrder">-->
			<!--<b-table class="mt-3" hover striped bordered small fixed responsive="sm" :items="filteredList"-->
							 <!--:fields="weightFields" :current-page="weightCurrentPage" :per-page="weightPerPage" :show-empty=true empty-text="리스트가 없습니다." :sort-by.sync="sortBy" :sort-desc=true>&lt;!&ndash;:sort-by="sortBy" :sort-desc="true" &ndash;&gt;-->
			<!--</b-table>-->
			<!--<nav>-->
				<!--<b-pagination :total-rows="filteredList.length" :per-page="weightPerPage" v-model="weightCurrentPage" prev-text="<" next-text=">" hide-goto-end-buttons/>-->
			<!--</nav>-->
		<!--</b-modal>-->
    <div ref="hoverImage" class="position-absolute d-none" style="left: 0 ;top:0; z-index: 9999;">
      <img class="w-25 h-25"/>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import moment from "moment/moment";
import { mapGetters, mapMutations, mapState } from 'vuex'
import { MODULE_NAME as PGM_MODULE } from '@/store/playGame/actions.type'
import { MODULE_NAME as PREG_MODULE, FETCH_CODES } from '@/store/preg/actions.type'
import { $showModalWithErrorMsg, $getLinkedSvcType, $getStatusName } from '@/common/util'
import { TABLE_CLASS_WITH_ELLIPSIS, TABLE_DATE_CLASS, DISPLAY_STATE } from '@/constants'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
import playGameService from '@/common/api/playGame.service'
export default {
	props : {
		config : {
			type : Object,
			required : true
		},
		listData : {
			type: Array,
			required : true
		}
	},
	components : {
		draggable
	},
	mounted () {
		this.$store.dispatch(PREG_MODULE + FETCH_CODES)
			.catch($showModalWithErrorMsg.bind(this))
	},
	data () {
		return {
      // weightFields: [
			// 	{key: 'seq', label: 'No.', class: 'align-middle text-center', thStyle: 'width: 80px'},
			// 	{key: 'title', label: '프로모션명', class: 'align-middle text-center'},
       //  {key: 'appName', label: '게임명', class: 'align-middle text-center'},
			// ],
			// weightPerPage: 20,
			// weightCurrentPage: 1,
	  DISPLAY_STATE: DISPLAY_STATE,
      perPage: 20,
      sortedDataList: [],
			currentPage: 1,
			search: '',
			fields: [
				{key: 'number', label: 'No.', class: 'align-middle text-center', thStyle: 'width: 80px'},
				{key: 'appName', label: '게임명', class: 'align-middle text-center'},
				{key: 'title', label: '프로모션명', class: 'align-middle text-center'},
				{key: 'type', label: '타입', class: 'align-middle text-center', thStyle: {width: '80px'}},
				{key: 'osType', label: '마켓', class: 'align-middle text-center', thStyle: {width: '80px'}},
				{key: 'zzd', label: '상태', class: 'align-middle text-center', thStyle: {width: '80px'}},
				// {key: 'zfzd', label: '적용순서', class: 'align-middle text-center'},
				{key: 'startTime', label: '노출시작', class: 'align-middle text-center ' + TABLE_DATE_CLASS},
				{key: 'endTime', label: '노출종료', class: 'align-middle text-center ' + TABLE_DATE_CLASS},
				{key: 'modTime', label: '등록/수정일', class: 'align-middle text-center '+ TABLE_DATE_CLASS},
				{key: 'modUserId', label: '등록/수정자', class: 'align-middle text-center'},
				{key: 'displayYn', label: 'On/Off', class: 'align-middle text-center'},
        {key: 'weight', label: '노출가중치', class: 'align-middle text-center', thStyle: 'width: 80px'}
			],
			bannerFields: [
				{key: 'number', label: 'No.', class: 'align-middle text-center', thStyle: 'width: 80px'},
				{key: 'title', label: '프로모션명', class: 'align-middle text-center'},
				{key: 'image', label: '배너 이미지', class: 'align-middle text-center'},
				{key: 'osType', label: '마켓', class: 'align-middle text-center', thStyle: {width: '80px'}},
				{key: 'zzd', label: '상태', class: 'align-middle text-center', thStyle: {width: '80px'}},
				{key: 'startTime', label: '노출시작', class: 'align-middle text-center ' + TABLE_DATE_CLASS},
				{key: 'endTime', label: '노출종료', class: 'align-middle text-center ' + TABLE_DATE_CLASS},
				{key: 'modTime', label: '등록/수정일', class: 'align-middle text-center ' + TABLE_DATE_CLASS},
				{key: 'modUserId', label: '등록/수정자', class: 'align-middle text-center'},
				{key: 'displayYn', label: 'On/Off', class: 'align-middle text-center'},
        {key: 'weight', label: '가중치 설정', class: 'align-middle text-center', thStyle: 'width: 80px'}
			],
			gameListFields: [
				{key: 'number', label: 'No.', class: 'align-middle text-center', thStyle: 'width: 80px'},
				{key: 'appName', label: '게임명', class: 'align-middle text-center'},
				{key: 'zzd', label: '상태', class: 'align-middle text-center', thStyle: {width: '80px'}},
				{key: 'startTime', label: '노출시작', class: 'align-middle text-center ' + TABLE_DATE_CLASS},
				{key: 'endTime', label: '노출종료', class: 'align-middle text-center ' + TABLE_DATE_CLASS},
				{key: 'modTime', label: '등록/수정일', class: 'align-middle text-center ' + TABLE_DATE_CLASS},
				{key: 'modUserId', label: '등록/수정자', class: 'align-middle text-center'},
        {key: 'weight', label: '가중치 설정', class: 'align-middle text-center', thStyle: 'width: 80px'}
			],
      mainStreamFields: [
        {key: 'number', label: 'No.', class: 'align-middle text-center', thStyle: 'width: 80px'},
        {key: 'appName', label: '게임명', class: 'align-middle text-center'},
        {key: 'title', label: '프로모션명', class: 'align-middle text-center'},
        {key: 'image', label: '배너 이미지', class: 'align-middle text-center'},
        {key: 'type', label: '타입', class: 'align-middle text-center', thStyle: {width: '80px'}},
        {key: 'osType', label: '마켓', class: 'align-middle text-center', thStyle: {width: '80px'}},
        {key: 'zzd', label: '상태', class: 'align-middle text-center', thStyle: {width: '80px'}},
        {key: 'startTime', label: '노출시작', class: 'align-middle text-center ' + TABLE_DATE_CLASS},
        {key: 'endTime', label: '노출종료', class: 'align-middle text-center ' + TABLE_DATE_CLASS},
        {key: 'modTime', label: '등록/수정일', class: 'align-middle text-center '+ TABLE_DATE_CLASS},
        {key: 'modUserId', label: '등록/수정자', class: 'align-middle text-center'},
        {key: 'displayYn', label: 'On/Off', class: 'align-middle text-center'},
        {key: 'weight', label: '노출가중치', class: 'align-middle text-center', thStyle: 'width: 80px'}
      ],
			sortBy: 'modTime',
			getLinkedSvcType: $getLinkedSvcType,
			getStatusName : $getStatusName,
			statusSelected: 'all',
			statusOptions: [
				{
				  value: 'all',
					text: '전체'
				},
				{
					value: 'now',
					text: '진행 중'
				},
				{
					value: 'future',
					text: '진행예정'
				},
				{
					value: 'past',
					text: '종료'
				}
			],
			linkedSvcTypeSelected: 'all',
			linkedSvcTypeOptions: [
				{
					value: 'all',
					text: '==== 전체 ===='
				},
				{
					value: 'preregistration',
					text: '사전예약'
				},
				{
					value: 'newgame',
					text: '신작출시'
				},
				{
					value: 'update',
					text: '업데이트'
				}
			],
			osTypeSelected: 'all',
			osTypeOptions: [
				{
					value: 'all',
					text: '==== OS 전체 ===='
				},
				{
					value: 'android',
					text: 'android'
				},
				{
					value: 'ios',
					text: 'ios'
				}
			],
			osTypeDesc: {
				'all': '전체',
				'ios': 'appStore',
				'android': 'googlePlay',
			},
			ON: true,
			OFF: false,
		}
	},
	methods : {
		movePgmAdEditPage(item) {
			console.log('item')
			console.log(item)
			console.log(item.linkedSvcInfo.pregMasterId)
			if (item.linkedSvcInfo.pregMasterId < 1000) {
				this.$router.push({
					name: this.config.type + 'Edit',
					params: {pgmAdId: '' + item.seq, linkedSvcType: item.linkedSvcType}
				})
			} else {
				this.$router.push({
					name: this.config.type + 'GapEdit',
					params: {pgmAdId: '' + item.seq, linkedSvcType: item.linkedSvcType}
				})
			}

		},
		movePgmAdRegisterPage(item) {
			console.log('item')
			console.log(item)
			console.log(item.linkedSvcInfo.pregMasterId)
			if (item.linkedSvcInfo.pregMasterId < 1000) {
				this.$router.push({name: config.type + 'New'})
			} else {
				this.$router.push({
					name: this.config.type + 'GapNew',
					params: {pgmAdId: '' + item.seq, linkedSvcType: item.linkedSvcType}
				})
			}

		},
    	weightHandler (item) {
			const confirm = window.confirm('가중치를 설정하시겠습니까?')
			if (confirm) {
			  this.changeListOrder()
			}
		},
		changeHandling(item, event) {
		    // 바꾸려고 선택한 값 : event.target.value
            // 기존 값 값 : item.displayYn
			const BERFORE = item.displayYn
		    const SELECTED = parseInt(event.target.value)

			let confirmText

			if(SELECTED === DISPLAY_STATE.ON) {
				confirmText = '노출(ON) 하시겠습니까?'
			} else if (SELECTED === DISPLAY_STATE.OFF) {
				confirmText = '비 노출(Off) 하시겠습니까?'
			} else {
              	confirmText = '베타 테스트용 노출 (BETA) 하시겠습니까?'
			}

			let isToggle = window.confirm(confirmText)
			let fail = () => {
              	this.$refs['type' + item.seq].value = BERFORE
				item.displayYn = BERFORE
        		$showModalWithErrorMsg.bind(this)
			}
			if (isToggle) {
              	item.displayYn = SELECTED

				switch (this.config.type) {
					case 'playGameFrontPopup':
						playGameService.updatePopup(item).catch(fail)
						break
					case 'playGameEmoticon':
						playGameService.updateEmoticon(item).catch(fail)
						break
					case 'playGameMainstream':
						playGameService.updateMainstream(item).catch(fail)
						break
					case 'playGameBanner':
						playGameService.updateBanner(item).catch(fail)
				}
			} else {
              	this.$refs['type' + item.seq].value = BERFORE
			  	item.displayYn = BERFORE
			}
		},
		getBannerImage (viewInfo) {
			if (typeof(viewInfo.contentUrl) === 'object') {
				return Object.values(viewInfo.contentUrl)[0]
			} else {
				return ''
			}
		},
    mouseEnterToBannerImage(mouseEvent) {
      //대세게임에만 적용
      if (!this.is('playGameMainstream')) {
        return;
      }
      this.$refs.hoverImage.classList.remove("d-none");
      this.$refs.hoverImage.style.top = (mouseEvent.currentTarget.getBoundingClientRect().top + window.scrollY) + "px"
      this.$refs.hoverImage.style.left = (mouseEvent.currentTarget.getBoundingClientRect().right + 10) + "px"
      this.$refs.hoverImage.querySelector("img").src = mouseEvent.currentTarget.src;
    },
    mouseLeaveFromBannerImage() {
      //대세게임에만 적용
      if (!this.is('playGameMainstream')) {
        return;
      }
      this.$refs.hoverImage.classList.add("d-none");
    },
    getTableField () {
			if (this.is('playGameBanner')) {
				return this.bannerFields
			} else if (this.is('playGameSnackgame') || this.is('playGameRecommend')) {
				return this.gameListFields
			} else if (this.is('playGameMainstream')){
        return this.mainStreamFields
      } else {
				return this.fields
			}
    },
		changeListOrder () {
      playGameService.updateOrder({list : this.sortedDataList})
        .then(() => {
        })
				.catch($showModalWithErrorMsg.bind(this))
		},
		orderNoSort (d1, d2) {
			if (Number(d1.orderNo) === Number(d2.orderNo)) {
				return 0
			}
			return Number(d1.orderNo) > Number(d2.orderNo) ? 1 : -1
		},
		is (type) {
      return type === this.config.type
		},
		...mapMutations('ui', [SHOW_MODAL])
	},
	computed : {
		filteredList () {
			return this.sortedDataList.filter((item) => {
				let linkedSvcTypeSelected = this.linkedSvcTypeSelected === 'all' ? item.linkedSvcType : this.linkedSvcTypeSelected
				let osTypeSelected = this.osTypeSelected === 'all' ? item.osType : this.osTypeSelected

				if (this.statusSelected === 'all') {
          return item.linkedSvcType === linkedSvcTypeSelected && (item.osType === osTypeSelected || item.osType === 'all') && (this.is('playGameBanner') ? item.title.includes(this.search) : item.appName.includes(this.search))
				}
				else {
          return item.linkedSvcType === linkedSvcTypeSelected && (item.osType === osTypeSelected || item.osType === 'all') && item.status === this.statusSelected && (this.is('playGameBanner') ? item.title.includes(this.search) : item.appName.includes(this.search))
				}
			})
		},
    orderOptions () {
		  const arr = []
		  for (let i = 0; i < 100; i++) {
		    arr.push({value: i + 1, text: i + 1})
			}
			return arr
		},
		...mapState('preg', [
      'codes'
    ])
	},
	watch : {
		listData (data) {
      this.sortedDataList = data.slice()
      this.sortedDataList.sort(this.orderNoSort)
		}
	}
}
</script>
<style scoped>
.dragList  {
	max-height: 500px;
	overflow-y: auto;
}
</style>
